import {
    Dialog,
    DialogContent,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from '@mui/material';
import { useState } from 'react';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { useTranslation } from 'react-i18next';
import AndroidOutlinedIcon from '@mui/icons-material/AndroidOutlined';
import AppleIcon from '@mui/icons-material/Apple';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import LanguageIcon from '@mui/icons-material/Language';
import AllOutIcon from '@mui/icons-material/AllOut';
import TabletIcon from '@mui/icons-material/Tablet';
import { UOTOST, UOPT } from '../userOrderProductDetails.classes';

function UserOutOfStockTable({ outOfStockItems, expanded, saleCh }: any) {
    const [openModal, setOpenModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const { t } = useTranslation();
    const handleOpenModal = (imageUrl: any) => {
        setSelectedImage(imageUrl);
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const renderCell = (saleCh: any) => {
        switch (saleCh) {
            case 'Android':
                return <AndroidOutlinedIcon />;
            case 'IOS':
                return <AppleIcon />;
            case 'MobileAssistant':
                return <SmartphoneIcon />;
            case 'WindowsPhone':
                return <PhoneAndroidIcon />;
            case 'Web':
                return <LanguageIcon />;
            case 'WebAPI':
                return <AllOutIcon />;
            case 'WKioskTablet':
                return <TabletIcon />;
            default:
                return null;
        }
    };
    return (
        <>
            <Dialog className={UOTOST.dialog} open={openModal} onClose={handleCloseModal}>
                <DialogContent className={UOTOST.dialogContent}>
                    <img className={UOPT.dialogImage} src={selectedImage} style={{ width: '400px', height: 'auto' }} alt="" />
                </DialogContent>
            </Dialog>
            <TableContainer className={UOTOST.tableContainer} style={{}}>
                <Table className={UOTOST.table}>
                    <TableHead>
                        <TableRow className={UOTOST.tableHeadRow}>
                            <TableCell className={UOTOST.photoCell}>{t('orderDetail.photo')}</TableCell>
                            <TableCell className={UOTOST.photoCell}>{t('orderDetail.product')}</TableCell>
                            <TableCell align="center">{t('orderDetail.saleCh')}</TableCell>
                            <TableCell align="center">{t('orderDetail.quantity')}</TableCell>
                            <TableCell align="center">{t('orderDetail.price')}</TableCell>
                            <TableCell align="center">{t('orderDetail.salePrice')}</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {outOfStockItems &&
                            outOfStockItems.map((row: any, index: any) => (
                                <>
                                    <TableRow
                                        key={index}
                                        className={`slide-animation ${expanded ? 'slide-in' : ''} ${UOTOST.bodyRow}`}
                                        style={{ animationDelay: `${index * 1}s` }}
                                    >
                                        <TableCell className={UOTOST.photoCell} align="left" style={{ borderBottom: 'none', minWidth: 200 }}>
                                            <div style={{ display: 'flex' }}>
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        display: 'inline-block',
                                                    }}
                                                >
                                                    <img
                                                        src={row.imageUrl}
                                                        alt={row.brandName}
                                                        style={{ width: '90px', height: 'auto' }}
                                                    />
                                                    <div
                                                        className={UOTOST.openImageIconWrap}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            right: 0,
                                                            cursor: 'pointer',
                                                            color: '#5b99f3',
                                                        }}
                                                        onClick={() => handleOpenModal(row.imageUrl)}
                                                    >
                                                        <ZoomInIcon className={UOPT.openImageIcon} style={{ height: 'auto', width: '20px' }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            scope="row"
                                            className={UOTOST.barcodeCell}
                                            style={{ borderBottom: 'none', maxWidth: 180 }}
                                        >
                                            <div>
                                                <Grid>
                                                    <p style={{ color: 'red' }}>{row.brandName}</p>
                                                </Grid>
                                                <Grid>{row.productDescriptionOnWebSite}</Grid>
                                                <Tooltip title={t('orderDetail.barcode')} placement="left">
                                                    <Grid>
                                                        <strong>{row.barcode}</strong>
                                                    </Grid>
                                                </Tooltip>
                                                <Tooltip title={t('orderDetail.specialAndColorCode')} placement="left">
                                                    <Grid>
                                                        <Link className={UOTOST.productLink} target="_blank" href={'/productDetail/' + row.optionId}>
                                                            {row.ozelKod1} - {row.renkKod}
                                                        </Link>
                                                    </Grid>
                                                </Tooltip>
                                                <Tooltip title={'OptionId'} placement="left">
                                                    <Grid>{row.optionId}</Grid>
                                                </Tooltip>
                                                <Tooltip
                                                    title={t('general.color') + ' - ' + t('orderDetail.size')}
                                                    placement="left"
                                                >
                                                    <Grid>{row.optionTitleKey + ' - ' + row.size}</Grid>
                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                        <TableCell align="center" style={{ borderBottom: 'none' }}>
                                            {renderCell(saleCh)} {saleCh}
                                        </TableCell>
                                        <TableCell align="center" style={{ borderBottom: 'none' }}>
                                            {row.quantity}
                                        </TableCell>
                                        <TableCell align="center" style={{ borderBottom: 'none' }}>
                                            {row.unitPrice} {import.meta.env.VITE_CURRENCY}
                                        </TableCell>
                                        <TableCell align="center" style={{ borderBottom: 'none' }}>
                                            {<strong>{row.salePrice}</strong>}
                                        </TableCell>
                                    </TableRow>
                                </>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

export default UserOutOfStockTable;
